import { OnboardingLiveSlotPlanStatus } from "../gql/graphql.ts";
import { classNames } from "../UI/Utils/classNames.ts";

const classesByStatus: Record<OnboardingLiveSlotPlanStatus, string> = {
  [OnboardingLiveSlotPlanStatus.Ok]: "bg-emerald-100 text-emerald-800",
  [OnboardingLiveSlotPlanStatus.Warning]: "bg-amber-100 text-amber-800",
  [OnboardingLiveSlotPlanStatus.Blocked]: "bg-red-100 text-red-800",
};

const labelByStatus: Record<OnboardingLiveSlotPlanStatus, string> = {
  [OnboardingLiveSlotPlanStatus.Ok]: "OK",
  [OnboardingLiveSlotPlanStatus.Warning]: "Con avvisi",
  [OnboardingLiveSlotPlanStatus.Blocked]: "Bloccato",
};

export function PlanStatusBadge({
  status,
}: {
  status: OnboardingLiveSlotPlanStatus;
}) {
  return (
    <span
      className={classNames(
        "inline-flex rounded-full px-2 py-0.5 text-xs font-medium",
        classesByStatus[status],
      )}
    >
      {labelByStatus[status]}
    </span>
  );
}
